export enum State {
  Untouched,
  InProgress,
  Completed,
  Failed,
  Cancelled,
}
